import {useState, useRef} from 'react';
import {Select, Tag} from 'antd';
import {getOptions, InvoiceStatusType} from "../../api/Constants";
import {updateInvoiceState} from "../../api/Api";

export const InvoiceStateWidget = ({invoice, onRefresh, onApiFail, disabled=true, props}) => {
    const [active, setActive] = useState(false);
    const options = getOptions(InvoiceStatusType)();
    const inputRef = useRef(null);

    const onSelect = (val) => {
        console.log(`select ${val}`)
        setActive(false);
        if (val === invoice.state) {
            return;
        }
        updateInvoiceState(invoice.id, val).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onClick = () => {
        if (disabled) return;
        setActive(true);
        setTimeout(() => {
            inputRef.current.focus();
        }, 40);
    }

    const onBlur = () => {
        setActive(false);
    }

    let tagColor = "#108ee9";
    switch (invoice.state) {
        case InvoiceStatusType.Created:
            tagColor = "#108ee9";
            break;
        case InvoiceStatusType.PaymentPending:
            tagColor = "#f77a05";
            break;
        case InvoiceStatusType.PartialPayment:
            tagColor = "#f55442";
            break;
        case InvoiceStatusType.FullPayment:
            tagColor = "#0ea133";
            break;
        case InvoiceStatusType.Complete:
            tagColor = "#8f8f8f";
            break;
        default:
    }

    if (active) {
        return <div>
            <Select ref={inputRef} value={invoice.state} options={options} onSelect={onSelect} onBlur={onBlur} popupMatchSelectWidth={false}/>
        </div>
    } else {
        return <div onClick={onClick} style={{cursor: 'pointer'}}>
            <Tag color={tagColor}>{InvoiceStatusType.Label[invoice.state]}</Tag>
        </div>
    }
}